import { colors } from './colors';

const borderColor = {
  DEFAULT: colors['gray-utility']['300'],
  primary: colors['gray-utility']['300'],
  secondary: colors['gray-light']['200'],
  tertiary: colors['gray-light']['100'],
  quaternary: colors['gray-light']['300'],
  disabled: colors['gray-utility']['200'],
  placeholder: colors['gray-utility']['300'],
  error: colors.error['600'],
  success: colors.success['600'],
  warning: colors.warning['600'],
  'brand-primary': colors.brand['500'],
  'brand-secondary': colors.brand['600'],
  'brand-tertiary': colors.brand['600'],
  'error-primary': colors.error['600'],
  'error-secondary': colors.error['500'],
  'warning-primary': colors.warning['600'],
  'success-primary': colors.success['400'],
  // Score tier edges: a lighter ring around the matching bg-score-* surface.
  'score-very-low': colors.error['100'],
  'score-low': colors.error['100'],
  'score-moderate': colors.orange['100'],
  'score-high': colors.yellow['100'],
  'score-very-high': colors.success['100'],
  'score-not-applicable': colors['gray-utility']['100'],
};

export { borderColor };
